
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as ShortLinkServices from "@/services/ShortServices";
import * as StatServices from "@/services/StatServices";

@Component
export default class InteractionsPerPartnerChart extends Vue {
  @Prop({ required: true }) from!: Date;
  @Prop({ required: true }) to!: Date;

  tab = 0;

  loading = false;
  allTags: string[] = [];

  selectedTags = [] as Array<string>;

  tagData = {} as Record<string, Array<any>>;
  tagColors = {} as Record<string, string>;

  async mounted() {
    const t = await ShortLinkServices.ListAllTags();
    this.allTags = t.map((tag) => tag.id);
    this.selectedTags = [];
  }

  lastFetchedDate = "";

  generateRandomColor(): string {
    // Generate random RGB values
    const r = Math.floor(Math.random() * 156) + 100; // 100-255 for vibrant colors
    const g = Math.floor(Math.random() * 156) + 100;
    const b = Math.floor(Math.random() * 156) + 100;
    // Convert to hex (always 100% opaque, no alpha channel)
    return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
  }

  get chartOptions() {
    return {
      chart: {
        id: "vistors",
      },
      colors: this.selectedTags.map(tag => this.tagColors[tag] || '#000000'),
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        type: "datetime",
      },
      dataLabels: {
        enabled: false,
      },
    };
  }

  series = [] as any[];

  @Watch("from", { immediate: true })
  @Watch("to")
  @Watch("selectedTags", { deep: true })
  async onDateChange() {
    this.lastFetchedDate = `${this.from.toISOString()} - ${this.to.toISOString()}`;
    
    // Assign random colors to new tags
    for (const tag of this.selectedTags) {
      if (!this.tagColors[tag]) {
        this.$set(this.tagColors, tag, this.generateRandomColor());
      }
    }

    // Remove colors for unselected tags
    const tagColorsToRemove = Object.keys(this.tagColors).filter(
      tag => !this.selectedTags.includes(tag)
    );
    tagColorsToRemove.forEach(tag => {
      this.$delete(this.tagColors, tag);
    });

    for (const tag of this.selectedTags) {
      const data = await StatServices.CountClicksPerShortLinkTag(
        this.from,
        this.to,
        tag
      );
      // is an object of string date and number, convert into an array with date and clicks
      this.tagData[tag] = Object.entries(data).map(([date, clicks]) => ({
        date,
        clicks,
      }));
    }

    this.series = this.selectedTags.map((tag) => ({
      name: tag,
      data: this.tagData[tag].map((d) => [
        new Date(d.date).getTime(),
        d.clicks,
      ]),
    }));
  }
}
